import * as React from "react";
import PicButton from '../../../../../../../../../../../../../../components/pic-button/index';

function ScheduleButton ({disabled, title, email}) {

	const handleClick = (e) => {
		e.stopPropagation();
		window.open(`https://calendar.google.com/calendar/u/0/r/eventedit?add=${email}&cls=0&hl=en`, '_blank');
	};

	return (
		<PicButton onClick={ handleClick } disabled={disabled} title={title || ''}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
				<path
					fill="currentColor"
					d="M 8.4 17.4 C 7.56 17.4 6.85 17.11 6.27 16.53 C 5.69 15.95 5.4 15.24 5.4 14.4 C 5.4 13.56 5.69 12.85 6.27 12.27 C 6.85 11.69 7.56 11.4 8.4 11.4 C 9.24 11.4 9.95 11.69 10.53 12.27 C 11.11 12.85 11.4 13.56 11.4 14.4 C 11.4 15.24 11.11 15.95 10.53 16.53 C 9.95 17.11 9.24 17.4 8.4 17.4 Z M 3.6 24 C 2.94 24 2.375 23.765 1.905 23.295 C 1.435 22.825 1.2 22.26 1.2 21.6 L 1.2 4.8 C 1.2 4.14 1.435 3.575 1.905 3.105 C 2.375 2.635 2.94 2.4 3.6 2.4 L 4.8 2.4 L 4.8 0 L 7.2 0 L 7.2 2.4 L 16.8 2.4 L 16.8 0 L 19.2 0 L 19.2 2.4 L 20.4 2.4 C 21.06 2.4 21.625 2.635 22.095 3.105 C 22.565 3.575 22.8 4.14 22.8 4.8 L 22.8 21.6 C 22.8 22.26 22.565 22.825 22.095 23.295 C 21.625 23.765 21.06 24 20.4 24 L 3.6 24 Z M 3.6 21.6 L 20.4 21.6 L 20.4 9.6 L 3.6 9.6 L 3.6 21.6 Z M 3.6 7.2 L 20.4 7.2 L 20.4 4.8 L 3.6 4.8 L 3.6 7.2 Z M 3.6 7.2 L 3.6 4.8 L 3.6 7.2 Z"
				/>
			</svg>
		</PicButton>
	)
}

export default ScheduleButton;
